import React from "react";
import PropTypes from "prop-types";

// import router link
import { Link } from "react-router-dom";

// import store, actions
import { connect } from "react-redux";
import {
  setAppTokenAsked,
  setAppTokenRetrieved,
  setFormation,
  togglePreloader,
} from "../../store/actions";

// import deep-equal
import equal from "deep-equal";

// import Flag
import Flag from "react-flagkit";

// import moment
import moment from "moment";
import "moment/locale/fr";

// import services
import { getFormation } from "../../services/formationService";
import { addComment } from "../../services/commentService";

// import utilities
import {
  formatArrayToString,
  isUnauthenticatedRequest,
  slugify,
} from "../../helpers/utilities";

// import dummies
import { COUNTRY, OPPORTUNITY, SCHOOL, TESTIMONY } from "../../helpers/dummies";

// import constants
import {
  APP_TOKEN,
  FORMATION_COST_DISCLAIMER,
  SCHOOL_ACCORDIONS,
  UNKNOWN_ERROR,
  USER_DATA,
} from "../../helpers/constants";

// import custom common components
import Banner from "../../components/common/Banner";
import Square from "../../components/common/Square";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import Maper from "../../components/common/Maper";
import Commenter from "../../components/common/Commenter";
import SocialShare from "../../components/common/SocialShare";
import ConvertCost from "../../components/common/ConvertCost";
import Sliders, { RESPONSIVES } from "../../components/common/Sliders";

// import custom components
import ListFormation from "../../components/custom/formations/ListFormation";

// import icons
import {
  icClassesRhythm,
  icDate,
  icDeadline,
  icDeliveryMode,
  icDuration,
  icLanguage,
  icMoney,
  mkSchool,
  icRightArrow,
} from "../../assets/images";

import Frame from '../../components/common/UniBanner';
// import rectangle27 from '../../assets/images/university/rectangle-27.png';
import face from '../../assets/images/university/face.png';
// import twitter from '../../assets/images/university/twitter.png';
// import youtube from '../../assets/images/university/youtube.png';
// import insta from '../../assets/images/university/insta.png';
// import whatsapp from '../../assets/images/university/whatsapp.png';
import tick from '../../assets/images/university/tick.png';
// import icon1 from '../../assets/images/university/icon1.png';
// import icon2 from '../../assets/images/university/icon2.png';
// import icon3 from '../../assets/images/university/icon3.png';
// import icon4 from '../../assets/images/university/icon4.png';
import share from '../../assets/images/university/share.png';
import like from '../../assets/images/university/like.png';
// import togo from '../../assets/images/university/togo.png';
import date from '../../assets/images/university/date.png';
// import clock from '../../assets/images/university/clock.png';
import person from '../../assets/images/university/person.png';
import lang from '../../assets/images/university/lang.png';
// import uniogo from '../../assets/images/university/unilogo.png';
// import background from '../../assets/images/university/background.png';
import degreeExample from '../../assets/images/university/degreeExample.png';
import articleexp from '../../assets/images/university/articleexp.png'

import { Accordion } from "react-bootstrap-accordion"; 

// custom sliders options
const SLIDERS_RESPONSIVES = {
  ...RESPONSIVES,
  desktop: { ...RESPONSIVES.desktop, items: 3 },
  tablet: { ...RESPONSIVES.tablet, items: 2 },
};

class Formation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      commenter: { loading: false, failure: "", success: false },
      showLoginLink: false,
      showSubsriptionLink: false,
      showCommentSection: false,
      showSocialShare: false,
      showCostConvert: false,
    };
  }

  componentDidMount() {
    try {
      //Get props
      let { onPreloaderToggled, location } = this.props;

      //Start preloader
      onPreloaderToggled(true, "Chargement de la formation");
      debugger
      // Load school
      this.onGetFormation();
    } catch (error) {
      console.log(error);
    }
  }

  componentDidUpdate(prevProps) {
    try {
      //Check props
      if (!equal(prevProps, this.props)) {
        //Get props
        let {
          tokenRetrieved,
          tokenFailed,
          onAppTokenRetrieved,
          onPreloaderToggled,
        } = this.props;

        //Handle props values
        if (tokenRetrieved && localStorage.getItem(APP_TOKEN)) {
          onAppTokenRetrieved(false);
          this.onGetFormation();
        } else if (tokenFailed) {
          onPreloaderToggled(false, "");
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  componentWillUnmount() {
    this.props.onSetFormation({});
  }

  /**
   * Toggle form modal.
   *
   * @param {*} option
   */
  onModalToggled = (option = "showSocialShare", visible = false) => {
    this.setState({ [option]: visible });
  };

  /**
   * Toggle form modal.
   *
   * @param {*} option
   */
  onConvertToggled = (option = "showCostConvert", visible = false) => {
    this.setState({ [option]: visible });
  };

  /**
   * On comment section showed.
   *
   */
  onCommentSectionShowed = () => {
    this.setState((prevState) => ({
      showCommentSection: !prevState.showCommentSection,
    }));
  };

  /**
   * Get domain.
   *
   */
  onGetFormation() {
   
    let { formationCode } = this.props.location.state;
    console.log("formation code getFormation",formationCode)
    let { onSetFormation, onPreloaderToggled, onAppTokenAsked } = this.props;
    getFormation(formationCode)
      .then((response) => {
        console.log({response})
        if (
          response &&
          response.publicId &&
          response.publicId === formationCode
        ) {
          let { schoolLogo, city, address, country, latitude, longitude } =
            response.school;
          let {
            language,
            formationRhythm,
            teachingMode,
            testimony,
            trainingDuration,
          } = response;
        
          onSetFormation({
            ...response,
            school: {
              ...response.school,
              schoolLogo: schoolLogo ? schoolLogo : SCHOOL.image,
              city: city ? city : COUNTRY.city,
              address: address ? address : COUNTRY.address,
              country: country ? country : COUNTRY,
              coordinates: {
                lat:
                  latitude != null && latitude !== ""
                    ? latitude
                    : OPPORTUNITY.coordinates.lat,
                lng:
                  longitude != null && longitude !== ""
                    ? longitude
                    : OPPORTUNITY.coordinates.lng,
              },
            },
            language: JSON.parse('"' + language.replace(/"/g, '\\"') + '"'),
            // formationRhythm: JSON.parse(formationRhythm),
            // teachingMode: JSON.parse(teachingMode),
            // testimony: testimony ? testimony : TESTIMONY.words,
            // trainingDuration: trainingDuration ? trainingDuration : 6,
          });

          onPreloaderToggled(false, "");
        } else if (isUnauthenticatedRequest(response)) {
          onAppTokenAsked(true);
        } else {
          onPreloaderToggled(false, "");
          console.error(response, "GET FORMATION ERROR");
        }
      })
      .catch((error) => {
        onPreloaderToggled(false, "");
        console.error(error, "GET FORMATION ERROR");
      });
  }

  /**
   * On Commented.
   *
   * @param {*} data
   */
  onCommented = (data) => {
    try {
      //Get props
      let { school } = this.props;

      //Start loader
      this.setState({
        commenter: { loading: true, failure: "", success: false },
      });

      //Launch save comment's request
      let comment_data = {
        content: data.comments,
        internationalOpening: data.internationalOpening,
        professionalPreparation: data.professionalPreparation,
        teachingQuality: data.teachingQuality,
        recommendSchool: data.recommendSchool,
        title: data.title,
        schoolId: school.id,
      };

      addComment(comment_data)
        .then((response) => {
          if (
            response.id &&
            response.school &&
            response.school.id &&
            response.school.id === school.id
          ) {
            this.setState({
              commenter: { loading: false, failure: "", success: true },
            });
          } else {
            console.error(response, "POST COMMENT ERROR");
            this.setState({
              commenter: {
                loading: false,
                failure: UNKNOWN_ERROR,
                success: false,
              },
            });
          }
        })
        .catch((error) => {
          console.error(error, "POST COMMENT ERROR");
          this.setState({
            commenter: {
              loading: false,
              failure: UNKNOWN_ERROR,
              success: false,
            },
          });
        });
    } catch (error) {
      console.log(error);
    }
  };

  onCreditReduced = () => {
    console.log("REDUCE USER/SCHOOL CREDITS");
  };

  onShared = () => {
    this.onCreditReduced();
    this.onModalToggled("showSocialShare", true);
  };

  onLiked = () => {
    console.log("ON LIKED");
    this.onCreditReduced();
  };

  render() {
    const { isPreloader, location} = this.props;
    // debugger
    // console.log("props",this.props)
    // debugger
    // console.log("locatioghhbjhbhjhjn",location)
    // debugger
    // console.log(formation)
    // const {
    //   id,
    //   publicId,
    //   name,
    //   dueDateOfNationalApply,
    //   dueDateOfInternationalApply,
    //   language,
    //   teachingMode,
    //   formationRhythm,
    //   trainingDuration,
    //   formationCost,
    //   recognizedByState,
    //   annualBackToSchool,
    //   school,
    //   testimony,
    //   domain,
    //   subDomain,
    //   formationsSuggest,
    // } = this.props;
    // const {
    //   commenter,
    //   showLoginLink,
    //   showSubsriptionLink,
    //   showCommentSection,
    //   showSocialShare,
    //   showCostConvert,
    // } = this.state;
    // console.log({
    //   id,
    //   publicId,
    //   name,
    //   dueDateOfNationalApply,
    //   dueDateOfInternationalApply,
    //   language,
    //   teachingMode,
    //   formationRhythm,
    //   trainingDuration,
    //   formationCost,
    //   recognizedByState,
    //   annualBackToSchool,
    //   school,
    //   testimony,
    //   domain,
    //   subDomain,
    //   formationsSuggest,
    // } )

    return (
      // <React.Fragment>
      //   <div id="formation" className={`${isPreloader ? "d-none" : "d-block"}`}>
      //     {id && publicId ? (
      //       <div id="formation-content">
      //         {/* Banner */}
      //         <Banner bannerId="domain-banner" withBackground />

      //         {/* Breadcrumbs */}
      //         <div className="container">
      //           <div className="row">
      //             <div className="col-lg-12">
      //               <Breadcrumbs
      //                 extratitle={school.country.name}
      //                 extratitleLink={`/pays/${school.country.publicId}`}
      //                 subtitle={school.name}
      //                 subtitleLink="#"
      //                 currentTile={`${name}`}
      //               />
      //             </div>
      //           </div>
      //         </div>

      //         <div className="box-single p-0 mb-0">
      //           {/* Top Section */}
      //           <div className="top-section shadow-sm py-5">
      //             <div className="container">
      //               <div className="d-flex justify-content-between">
      //                 <div className="first-column">
      //                   <small className="d-block text-muted">
      //                     {school.name}
      //                   </small>
      //                   <h3 className="mb-2">{name}</h3>
      //                   <div className="single-meta p-0">
      //                     <ul>
      //                       {recognizedByState ? (
      //                         <li>
      //                           <span className="d-flex align-items-center">
      //                             <i className="bx bxs-check-circle text-green me-1"></i>
      //                             Reconnu par l'État
      //                           </span>
      //                         </li>
      //                       ) : null}
      //                     </ul>
      //                   </div>
      //                 </div>
      //                 <div className="p-0 single-meta second-column">
      //                   <ul>
      //                     <li>
      //                       <span title="Date de la prochaine rentrée">
      //                         <img
      //                           src={icDate}
      //                           width={24}
      //                           height={24}
      //                           alt="date icon"
      //                         />{" "}
      //                         {annualBackToSchool !== ""
      //                           ? `${moment(
      //                               new Date(annualBackToSchool)
      //                             ).format("DD MMM YYYY")}`
      //                           : "Non renseigné"}
      //                       </span>
      //                     </li>

      //                     <li>
      //                       <span title="Durée de la formation">
      //                         <img
      //                           src={icDuration}
      //                           width={24}
      //                           height={24}
      //                           alt="duration icon"
      //                         />{" "}
      //                         {trainingDuration !== null
      //                           ? `${trainingDuration} mois`
      //                           : "Non renseigné"}
      //                       </span>
      //                     </li>

      //                     <li>
      //                       <span
      //                         title={`Format${
      //                           teachingMode !== null && teachingMode.length > 1
      //                             ? "s"
      //                             : ""
      //                         } d’apprentissage`}
      //                       >
      //                         <img
      //                           src={icDeliveryMode}
      //                           width={24}
      //                           height={24}
      //                           alt="formats icon"
      //                         />{" "}
      //                         {teachingMode !== null && teachingMode.length > 0
      //                           ? formatArrayToString(teachingMode)
      //                           : "Non renseigné"}
      //                       </span>
      //                     </li>

      //                     <li>
      //                       <span
      //                         title={`Langue${
      //                           language !== null && language.length > 1
      //                             ? "s"
      //                             : ""
      //                         } d’enseignement`}
      //                       >
      //                         <img
      //                           src={icLanguage}
      //                           width={24}
      //                           height={24}
      //                           alt="langues icon"
      //                         />{" "}
      //                         {language !== null && language.length > 0
      //                           ? formatArrayToString(language)
      //                           : "Non renseigné"}
      //                       </span>
      //                     </li>
      //                   </ul>
      //                 </div>
      //                 <div className="p-0 single-meta third-column">
      //                   <ul>
      //                     <li>
      //                       <span
      //                         title={`Rythme${
      //                           formationRhythm !== null &&
      //                           formationRhythm.length > 1
      //                             ? "s"
      //                             : ""
      //                         } d’enseignement`}
      //                       >
      //                         <img
      //                           src={icClassesRhythm}
      //                           width={24}
      //                           height={24}
      //                           alt="rythmes icon"
      //                         />{" "}
      //                         {formationRhythm !== null &&
      //                         formationRhythm.length > 0
      //                           ? formatArrayToString(formationRhythm)
      //                           : "Non renseigné"}
      //                       </span>
      //                     </li>

      //                     <li>
      //                       <span title="Date limite de candidature étudiants nationaux">
      //                         <img
      //                           src={icDeadline}
      //                           width={24}
      //                           height={24}
      //                           alt="date icon"
      //                         />{" "}
      //                         {dueDateOfNationalApply !== ""
      //                           ? `${moment(
      //                               dueDateOfNationalApply,
      //                               "DD-MM-YYYY HH:mm:ss"
      //                             ).format("DD MMM YYYY")}`
      //                           : "Non renseigné"}
      //                       </span>
      //                     </li>

      //                     <li>
      //                       <span title="Date limite de candidature étudiants internationaux">
      //                         <img
      //                           src={icDeadline}
      //                           width={24}
      //                           height={24}
      //                           alt="date icon"
      //                         />{" "}
      //                         {dueDateOfInternationalApply !== ""
      //                           ? `${moment(
      //                               dueDateOfInternationalApply,
      //                               "DD-MM-YYYY HH:mm:ss"
      //                             ).format("DD MMM YYYY")}`
      //                           : "Non renseigné"}
      //                       </span>
      //                     </li>

      //                     <li
      //                       className="cursor-hand"
      //                       onClick={() =>
      //                         this.onConvertToggled("showCostConvert", true)
      //                       }
      //                     >
      //                       <span
      //                         title={`Estimation du coût(${FORMATION_COST_DISCLAIMER})`}
      //                       >
      //                         <img
      //                           src={icMoney}
      //                           width={24}
      //                           height={24}
      //                           alt="cost icon"
      //                         />{" "}
      //                         {formationCost !== null
      //                           ? `XOF ${formationCost}`
      //                           : "Non renseigné"}
      //                       </span>
      //                     </li>
      //                   </ul>
      //                 </div>
      //                 <div className="school-reviews fourth-column">
      //                   <div className="reviews">
      //                     <div className="reviews-stars">
      //                       <i className="bx bxs-star text-muted"></i>
      //                       <i className="bx bxs-star text-muted"></i>
      //                       <i className="bx bxs-star text-muted"></i>
      //                       <i className="bx bxs-star text-muted"></i>
      //                       <i className="bx bxs-star text-muted"></i>
      //                       <span className="cursor-hand ms-1 text-muted">
      //                         {`(${school.note ? school.note : "0"})`}
      //                       </span>
      //                     </div>
      //                     <div className="reviews-actions justify-content-end mt-2">
      //                       <span
      //                         className="px-2 py-1 d-flex align-items-center justify-content-center me-1"
      //                         onClick={() => this.onLiked()}
      //                       >
      //                         <i className="bx bx-like me-1" /> J’aime
      //                       </span>
      //                       <span
      //                         className="px-2 py-1 d-flex align-items-center justify-content-center ms-1"
      //                         onClick={() => this.onShared()}
      //                       >
      //                         <i className="bx bx-share-alt me-1" /> Partager
      //                       </span>
      //                     </div>
      //                   </div>
      //                   <div className="d-flex align-items-center justify-content-end mt-3">
      //                     {school.admissionLink !== null &&
      //                     school.admissionLink !== "" ? (
      //                       <a
      //                         id="btn-candidate"
      //                         href={school.admissionLink}
      //                         className="btn-apply"
      //                         target="_blank"
      //                         rel="noopener noreferrer"
      //                       >
      //                         Je candidate
      //                       </a>
      //                     ) : (
      //                       <Link
      //                         id="btn-candidate"
      //                         className="btn-apply"
      //                         to={{
      //                           pathname: `/etablissements/${slugify(
      //                             school.name
      //                           )}/apply`,
      //                           state: {
      //                             schoolCode: school.publicId,
      //                             isSchoolPublic: school.isPublic,
      //                             schoolName: school.name,
      //                           },
      //                         }}
      //                       >
      //                         Je candidate
      //                       </Link>
      //                     )}
      //                   </div>
      //                 </div>
      //               </div>
      //             </div>
      //           </div>

      //           {/* Content Section */}
      //           <div className="content-section py-4 mb-5">
      //             <div className="container">
      //               <div className="row g-0 gx-4">
      //                 <div className="col-lg-3">
      //                   <Square squareClasses="mb-3">
      //                     <div className="square-item square-recents mb-0">
      //                       <div className="d-flex align-items-center">
      //                         <img
      //                           src={school.schoolLogo}
      //                           className="img-fluid me-1"
      //                           width={115}
      //                           height={115}
      //                           alt={school.name.toLowerCase()}
      //                         />
      //                         <div className="d-flex flex-column">
      //                           <h5 className="mb-0">{school.name}</h5>

      //                           <div className="d-flex align-items-center mt-2">
      //                             {school.country.name}{" "}
      //                             {school.country.countryCode &&
      //                             school.country.countryCode !== "" ? (
      //                               <Flag
      //                                 country={school.country.countryCode.toUpperCase()}
      //                                 className="ms-2 border border-dark"
      //                                 height={16}
      //                                 width={22}
      //                               />
      //                             ) : null}
      //                           </div>
      //                         </div>
      //                       </div>

      //                       <div className="d-flex align-items-center justify-content-center mt-3">
      //                         <Link
      //                           id="btn-school-profile"
      //                           to={{
      //                             pathname: `/etablissements/${slugify(
      //                               school.name
      //                             )}`,
      //                             state: {
      //                               code: school.publicId,
      //                               isPublic: school.isPublic,
      //                               name: school.name,
      //                             },
      //                           }}
      //                           className="btn-apply text-center"
      //                         >
      //                           Profil de l'établissement
      //                         </Link>
      //                       </div>

      //                       <div className="mt-2 text-center">
      //                         <Link
      //                           to={{
      //                             pathname: `/etablissements/${slugify(
      //                               school.name
      //                             )}`,
      //                             state: {
      //                               schoolCode: school.publicId,
      //                               isSchoolPublic: school.isPublic,
      //                               schoolName: school.name,
      //                             },
      //                           }}
      //                           className="fs-14 text-muted text-center"
      //                         >
      //                           Des questions ?
      //                           <br />
      //                           Trouvez des réponses ici
      //                         </Link>
      //                       </div>
      //                     </div>
      //                   </Square>

      //                   <Square squareClasses="mb-3">
      //                     <h3 className="square-title">
      //                       {`Adresse de ${school.name}`}
      //                     </h3>
      //                     <div className="square-item square-recents mb-0">
      //                       <div className="mb-3">
      //                         {school.address}
      //                         {`${school.city ? `, ${school.city}` : ""}`}
      //                         {school.country && school.country.name
      //                           ? `, ${school.country.name}`
      //                           : ""}
      //                       </div>
      //                       <Maper
      //                         items={{ coordinates: school.coordinates }}
      //                         size="300"
      //                         icon={mkSchool}
      //                       />
      //                     </div>
      //                   </Square>

      //                   <div className="ads">
      //                     <div className="rectangle center-box">
      //                       PUB LATÉRAL ICI
      //                     </div>
      //                   </div>

      //                   <div className="my-3" />

      //                   <div className="ads">
      //                     <div className="rectangle center-box">
      //                       PUB LATÉRAL ICI
      //                     </div>
      //                   </div>
      //                 </div>

      //                 <div className="col-lg-9 px-4">
      //                   <div className="ads">
      //                     <div className="leaderboard center-box">
      //                       PUB MOYENNE ICI
      //                     </div>
      //                   </div>

      //                   {testimony && testimony.videoLink ? (
      //                     <div className="row mt-5">
      //                       <div className="col-lg-12">
      //                         <div className="student-testimony-video">
      //                           <video controls>
      //                             <source
      //                               src={testimony.videoLink}
      //                               type="video/mp4"
      //                             />
      //                             Votre navigateur ne prend pas en charge la
      //                             balise vidéo.
      //                           </video>
      //                         </div>
      //                       </div>
      //                     </div>
      //                   ) : testimony && testimony.content ? (
      //                     <div className="row mt-5">
      //                       <div className="col-lg-12">
      //                         <div className="student-testimony mx-5 bg-light rounded p-4">
      //                           <figure>
      //                             <blockquote className="blockquote">
      //                               <p className="fs-15">{testimony.content}</p>
      //                             </blockquote>
      //                             <figcaption className="blockquote-footer mb-0 mt-1">
      //                               {testimony.author},{" "}
      //                               <cite title="Source Title">
      //                                 {testimony.authorLevel}
      //                               </cite>
      //                             </figcaption>
      //                           </figure>
      //                         </div>
      //                       </div>
      //                     </div>
      //                   ) : null}

      //                   <div className="row mt-5">
      //                     <div className="col-lg-12">
      //                       <div
      //                         className="accordion content-accordion"
      //                         id="accordionSchoolContent"
      //                       >
      //                         {SCHOOL_ACCORDIONS.map((item, index) => (
      //                           <div
      //                             key={`school_accordion_${index}`}
      //                             className="accordion-item"
      //                           >
      //                             <h2
      //                               className="accordion-header"
      //                               id={`heading${item.key}`}
      //                             >
      //                               <button
      //                                 className="accordion-button accordion-btn collapsed"
      //                                 type="button"
      //                                 data-bs-toggle="collapse"
      //                                 data-bs-target={`#collapse${item.key}`}
      //                                 aria-expanded="false"
      //                                 aria-controls={`collapse${item.key}`}
      //                               >
      //                                 {item.label}
      //                               </button>
      //                             </h2>
      //                             <div
      //                               id={`collapse${item.key}`}
      //                               className="accordion-collapse collapse"
      //                               aria-labelledby={`heading${item.key}`}
      //                               data-bs-parent="#accordionSchoolContent"
      //                             >
      //                               <div className="accordion-body">
      //                                 {formation[item.key] &&
      //                                 formation[item.key] !== "" ? (
      //                                   <div
      //                                     dangerouslySetInnerHTML={{
      //                                       __html: formation[item.key],
      //                                     }}
      //                                   />
      //                                 ) : (
      //                                   <>Non renseigné</>
      //                                 )}
      //                               </div>
      //                             </div>
      //                           </div>
      //                         ))}
      //                       </div>
      //                     </div>

      //                     <div className="col-lg-12 availables-formations mt-5">
      //                       <h5 className="mb-0 fw-bold">
      //                         Autres formations similaires disponibles
      //                       </h5>
      //                       {formationsSuggest &&
      //                       formationsSuggest.length > 0 ? (
      //                         <Sliders
      //                           slidersClasses="availables-sliders"
      //                           responsiveOptions={SLIDERS_RESPONSIVES}
      //                         >
      //                           {formationsSuggest
      //                             .slice(0, 6)
      //                             .map((item, index) => (
      //                               <div
      //                                 key={`suggest_formation_item_${index}`}
      //                                 className="box"
      //                               >
      //                                 <Link
      //                                   to={{
      //                                     pathname: `/formations/${slugify(
      //                                       item.name
      //                                     )}`,
      //                                     state: {
      //                                       formationCode: item.publicId,
      //                                       formationName: item.name,
      //                                     },
      //                                   }}
      //                                 >
      //                                   <div className="d-flex flex-column">
      //                                     <h5 className="mb-2">
      //                                       {" "}
      //                                       {item.name}{" "}
      //                                     </h5>
      //                                     <span className="d-flex align-items-center justify-content-center">
      //                                       <img
      //                                         width={30}
      //                                         height={30}
      //                                         src={icRightArrow}
      //                                         alt="available formation arrow"
      //                                       />
      //                                     </span>
      //                                   </div>
      //                                 </Link>
      //                               </div>
      //                             ))}
      //                         </Sliders>
      //                       ) : (
      //                         <p className="m-0 p-2">
      //                           Aucune formation similaire disponible.
      //                         </p>
      //                       )}
      //                     </div>

      //                     <div className="col-lg-12 leave-comment mt-5">
      //                       <button
      //                         type="button"
      //                         className="btn-leave-comment"
      //                         onClick={() => this.onCommentSectionShowed()}
      //                       >
      //                         {`${
      //                           showCommentSection
      //                             ? "Réduire"
      //                             : "Laisser un commentaire"
      //                         }`}{" "}
      //                         <i
      //                           className={`bx bx-${
      //                             showCommentSection ? "up" : "down"
      //                           }-arrow-alt text-light`}
      //                         />
      //                       </button>
      //                       {showCommentSection ? (
      //                         <div className="mt-3">
      //                           <h5 className="mb-2 fw-bold">
      //                             Ancien.ne étudiant.e ? Partagez votre
      //                             expérience en laissant un commentaire
      //                           </h5>
      //                           <div className="content">
      //                             {localStorage.getItem(USER_DATA) ? (
      //                               <Commenter
      //                                 onCommented={this.onCommented}
      //                                 {...commenter}
      //                               />
      //                             ) : (
      //                               <p className="m-0">
      //                                 <Link
      //                                   to={{
      //                                     pathname: `/login`,
      //                                     state: { from: location },
      //                                   }}
      //                                 >
      //                                   Connectez-vous
      //                                 </Link>{" "}
      //                                 à votre compte membre pour laisser un
      //                                 commentaire.
      //                               </p>
      //                             )}
      //                           </div>
      //                         </div>
      //                       ) : null}
      //                     </div>
      //                   </div>
      //                 </div>
      //               </div>
      //             </div>
      //           </div>
      //         </div>
      //       </div>
      //     ) : (
      //       <div className="container py-5">
      //         <div className="row py-5">
      //           <div className="col-lg-12 py-5">
      //             <center>
      //               <p>Cette formation est introuvable.</p>
      //               <p className="mb-0">
      //                 Continuer sur <a href="/">l'accueil</a> ou sur la page{" "}
      //                 <a href="/">précédente</a>.
      //               </p>
      //             </center>
      //           </div>
      //         </div>
      //       </div>
      //     )}
      //   </div>
      //   {showSocialShare && school && school.publicId ? (
      //     <SocialShare
      //       opened={showSocialShare}
      //       shareLink={`http://localhost:3000/etablissements/${slugify(
      //         school.name
      //       )}`}
      //       shareMessage="Découvre cet établissement d'exception"
      //       title="Partager un établissement"
      //       subtitle={`Partager ${school.name} sur les réseaux sociaux et autres plateformes...`}
      //       onClosed={this.onModalToggled}
      //     />
      //   ) : null}
      //   {showCostConvert && formationCost ? (
      //     <ConvertCost
      //       opened={showCostConvert}
      //       cost={formationCost}
      //       onClosed={this.onConvertToggled}
      //     />
      //   ) : null}
      // </React.Fragment>
      <React.Fragment>
      {/* <div id="" className={`${isPreloader ? "d-none extraBody" : "d-block extraBody"}`}> */}

         {/* Breadcrumbs */}
         <div className="container">
                      <div className="row">
                          <div className="col-lg-12">
                              <Breadcrumbs
                              extratitle="Côte d’lvoire"
                                  subtitle="Établissements"
                                  currentTile="Académie Régionale des Sciences et Techniques"
                              />
                          </div>
                      </div>
         </div> 

        <Frame  property1="default" className="rectangle" />
        <div className="divider"> </div>
      <div className='inforamtion'></div>

      {/* second section*/}
      <div className="secondContainerMain">
      <div className="degreeSecondSectionContainer">
          <div className="degreeSecondSectionContainerInnerDiv">
              <div className="degreeInfoDiv">
                  <div className="degreeInfoDivSection">
                      <div className="degreeInfoDivSectionHeading1">Agroalimentaire</div>
                      <div className="degreeInfoDivSectionHeading2">Graduação em design da informação (ESA) </div>
                  </div>
                  <div className="degreeInfoSectionshareContainer">
                      <div className="degreeInfoSectionshareoptions">
                          <div className="degreeInfoSectionshareoptionsText">Partager</div>
                          <img  src={share}  alt="Share Icon" />
                      </div>
                      <div className="degreeInfoSectionshareoptions">
                          <div className="degreeInfoSectionshareoptionsText">Suivre</div>
                          <img  src={like}  alt="like Icon" />
                      </div>
                  </div>
              </div>
          
              <div className="degreeInfoSectionBottom">
                  <div className="degreeInfoSectionBottomInnerDiv">
                      <div className="degreerecon">
                      <img  src={tick} alt="tick Icon"/>
                          <div className="degreereconText">Reconnu par l’État</div>
                      </div>
                      <div className="degreereInfodivi"></div>
                      <div className="degreeInfoSectionBottomSecond">
                          <div className="degreestarContainer">
                              <div className="starglow"></div>
                              <div className="startlight"></div>
                          </div>
                          <div className="degreeInfoVour">
                              <div className="degreeInfoVourInner">voir les avis</div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      {/* bottom options */}

      <div className="degreeinfooptionsContainer">
          <div className="degreeinfooptionUpperDiv">
              <div className="degreeinfooptionUpperDivFirst">
                  <img   src={date} alt="date Icon"/> 
                  <div className="degreeinfooptionUpperDivFirstInner">
                      <div className="degreeinfooptionUpperDivFirstInnerLabel">April 20, 2024</div>
                      <div className="degreeinfooptionUpperDivFirstInnerLabelsec">Prochaine rentrée</div>
                  </div>
              </div>
              <div className="degreeinfooptionUpperDivFirst">
              <img   src={date} alt="date Icon" /> 
                  <div className="degreeinfooptionUpperDivFirstInner">
                      <div className="degreeinfooptionUpperDivFirstInnerLabel">Full-time</div>
                      <div className="degreeinfooptionUpperDivFirstInnerLabelsec">Length of degree</div>
                  </div>
              </div>
              <div className="degreeinfooptionUpperDivFirst">
              <img   src={person} alt="person Icon" />  
                  <div className="degreeinfooptionUpperDivFirstInner">
                      <div className="degreeinfooptionUpperDivFirstInnerLabel">In person</div>
                      <div className="degreeinfooptionUpperDivFirstInnerLabelsec">Formats d'apprentissage</div>
                  </div>
              </div>
              <div className="degreeinfooptionUpperDivFirst">
              <img   src={lang} alt="lang Icon" />
                  <div className="degreeinfooptionUpperDivFirstInner">
                      <div className="degreeinfooptionUpperDivFirstInnerLabel">French and English</div>
                      <div className="degreeinfooptionUpperDivFirstInnerLabelsec">Langue d'enseignement</div>
                  </div>
              </div>
          </div>
          <div className="degreeInfoRest"></div>
          <div className="degreeinfooptionBottomDivFirst">
              <div className="degreeinfooptionUpperDivFirst">
              <img   src={date} alt="date Icon"  /> 
                  <div className="degreeinfooptionUpperDivFirstInner">
                      <div className="degreeinfooptionUpperDivFirstInnerLabel">April 20, 2024</div>
                      <div className="degreeinfooptionUpperDivFirstInnerLabelsec">Rythme <br/>de formation</div>
                  </div>
              </div>
              <div className="degreeinfooptionUpperDivFirst">
              <img   src={person} alt="person Icon"  /> 
                  <div className="degreeinfooptionUpperDivFirstInner">
                      <div className="degreeinfooptionUpperDivFirstInnerLabel">April 20, 2024</div>
                      <div className="degreeinfooptionUpperDivFirstInnerLabelsec">Date limite de candidature <br/> étudiants internationaux</div>
                  </div>
              </div>
              <div className="degreeinfooptionBottomDivFirstInnercontainer">
              <img   src={date} alt="person Icon" /> 
                  <div className="degreeinfooptionBottomDivFirstInnercontainerItemContainer">
                      <div className="degreeinfooptionUpperDivFirstInnerLabel">April 20, 2024</div>
                      <div className="degreeinfooptionUpperDivFirstInnerLabelsec">Date limite de candidature <br/>étudiants internationaux</div>
                  </div>
              </div>
              <div className="degreeinfooptionBottomDivFirstInnercontainer">
                  <div className="degreeinfooptionBottomDivFirstInnercontainerItemContainer">
                      <div className="degreeinfoextraContainer">
                          <div className="degreeinfoextraContainerInner">
                              <div className="degreeinfoextraContainerInnerLabel">XOF </div>
                              <div className="degreeinfoextraContainerInnerLabelExt"></div>
                          </div>
                          <div className="degreeInfoLastBottomDivLabel">12.000.000</div>
                      </div>
                      <div className="degreeinfooptionUpperDivFirstInnerLabelsec">Estimation du cout en <br/>CFA et convertisseurs</div>
                  </div>
              </div>
          </div>
      </div>
 
  </div>

  <div className="divider"> </div>    
  {/* third section */}
   
  <div className="degree3rdSectionContainer">
      <div className="degree3rdSectionLeftContainer">
          <div className="degree3rdSectionIstContainer">
              <div className="degree3rdSectionIstInformationContainer">
                  <div className="degree3rdSectionIstInformationContainerInner">
                      <img className="degree3rdSectionIstInformationLogo" src={degreeExample} alt=""/>
                      <div className="degree3rdSectionIstInformationDetails">
                          <div className="degree3rdSectionIstInformationDegreeName">Nome da Universidade (ARS)</div>
                          <div className="degree3rdSectionRatingContainer">
                              <div className="degreeRatingText"></div>
                          </div>
                          <div className="degree3rdSectionIsttags">
                              <div className="justify-content: flex-start; align-items: center; gap: 8px; display: flex">
                                  <div><span className="degree3rdSectiontagLabels">Lomé • </span>
                                  <span className="degree3rdSectiontagLabels">Togo</span>
                                  </div>
                              </div>
                          </div>
                          <div className="degree3rdSectionerecon">
                              <div className="degree3rdSectionerecontext">Reconnu par l’État</div>
                          </div>
                      </div>
                  </div>
              </div>
              <div className="degree3rdSectionIstsocialContainer">
                  <div className="degree3rdSectionIstsocialInner">
                      <div className="degree3rdSectionIstsocialInnerDiv">
                          <img  src={face} alt="" />
                      </div>
                      <div className="degree3rdSectionIstsocialInnerDiv">
                          <img  src={face}  alt=""/>
                      </div>
                      <div className="degree3rdSectionIstsocialInnerDiv">
                          <img  src={face}  alt=""/>
                      </div>
                      <div className="degree3rdSectionIstsocialInnerDiv">
                          <img  src={face}  alt=""/>
                      </div>
                      <div className="degree3rdSectionIstsocialInnerDiv">
                          <img  src={face} alt=""/>
                      </div>
                  </div>
                  <div className="degree3rdSectionIstProfileButtonContainer">
                      <div className="degree3rdSectionIstProfileButtonContainerInner">
                          <div className="degree3rdSectionIstProfileButtonContainerInnerContent">Profil de l’école</div>
                      </div>
                  </div>
              </div>
          </div>
          <div className="degree3rdSectionLeftSecondContainer">
              <div className="degree3rdSectionSecondDivAdressContainer">
                  <div className="degree3rdSectionSecondDivAdressContainerInner">
                      <div className="degree3rdSectionSecondDivAdressLabel">Adresse</div>
                      <div className="degree3rdSectionSecondDivAdressLabelContent">BPV 158 Abidjan, Abidjan, Costa do Marfim</div>
                  </div>
              </div>
              <div className="degree3rdSectionMapExtra">
              {/* <Maper
                  withPopup
                  icon={mkSchool}
                  items={filteredResults}
                  redirectLink="/schools" 
                  zIndex={zIndex}
                  size="350"
              /> */}
              </div>
           {/*   <img className="degree3rdSectionMapExtra" src="https://via.placeholder.com/320x266" /> */}
          </div>
          <div className="degree3rdSectionArticleContainer">
              <div className="degree3rdSectionArticleHeadingContainer">
                  <div className="degree3rdSectionArticleHeading">Related Articles</div>
              </div>
              <div className="degree3rdSectionSingleArticleContainer">
                  <div className="degree3rdSectionSingleArticleContainerInner">
                      <div className="degree3rdSectionSingleArticleContainerInnerDiv">
                          <div className="degree3rdSectionSingleArticleContainerInnerDivCon">
                              <img className="degree3rdSectionArticleImage" src={articleexp} alt=""/>
                              <div className="degree3rdSectionArticleDescrContainer">
                                  <div className="degree3rdSectionArticleDescrContainerCon">Lorem ipsum dolor sit ame</div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div className="degree3rdSectionSingleArticleContainer">
                  <div className="degree3rdSectionSingleArticleContainerInner">
                      <div className="degree3rdSectionSingleArticleContainerInnerDiv">
                          <div className="degree3rdSectionSingleArticleContainerInnerDivCon">
                              <img className="degree3rdSectionArticleImage" src={articleexp} alt=""/>
                              <div className="degree3rdSectionArticleDescrContainer">
                                  <div className="degree3rdSectionArticleDescrContainerCon">Lorem ipsum dolor sit ame</div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div className="degree3rdSectionRightSideContainer">
          <img className="degree3rdSectionRightExtraD" src="https://via.placeholder.com/640x419"  alt=""/>
          
          <div className="degree3rdSectionRightSideAccordingContainer">
              
          <Accordion title="Presentation">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi
              eligendi odit ducimus eos maiores, reiciendis numquam voluptas
          </Accordion>
          <Accordion title="Conditions d’admission">
              <div className="degreeContactAccordingContentContainer">
              <div className="degreeContactAccordingContentContainerInner">
                  <div className="degreeAccordingInnerQuestionHeadingContain">
                      <div className="degreeAccordingInnerQuestionHeading">Suggestions de questions pour votre contact</div>
                      <div className="degreeAccordingInnerQuestionHeadingBottom"></div>
                  </div>
                  <div className="degreeAccordingInnerQuestionFaqContainer">
                      <div className="degreeAccordingInnerQuestionFaqistContain">
                          <div className="degreeAccordingInnerQuestionFaqist">Pouvez-vous m’envoyer des informations sur votre établissement? (brochure)</div>
                      </div>
                      <div className="degreeAccordingInnerQuestionFaqistContain">
                          <div className="degreeAccordingInnerQuestionFaqist">Quelle est la date de la prochaine rentrée?</div>
                      </div>
                  </div>
                  <div className="degreeAccordingInnerQuestionFaqContainer">
                      <div className="degreeAccordingInnerQuestionFaqistContain">
                          <div className="degreeAccordingInnerQuestionFaqist">L’établissement offre t-il des bourses aux étudiants du 1er cycle?</div>
                      </div>
                      <div className="degreeAccordingInnerQuestionFaqistContain">
                          <div className="degreeAccordingInnerQuestionFaqist">L’établissement offre t-il des bourses aux étudiants des cycles supérieur?</div>
                      </div>
                  </div>
                  <div className="degreeAccordingInnerQuestionFaqContainer">
                      <div className="degreeAccordingInnerQuestionFaqistContain">
                          <div className="degreeAccordingInnerQuestionFaqist">Quelles sont les modalités et aménagement de paiement disponibles?</div>
                      </div>
                      <div className="degreeAccordingInnerQuestionFaqistContain">
                          <div className="degreeAccordingInnerQuestionFaqist">Il y’a t’il une résidence/logement sur le campus ou géré par l’établissement?</div>
                      </div>
                  </div>
                  <div className="degreeAccordingInnerQuestionFaqContainer">
                      <div className="degreeAccordingInnerQuestionFaqistContain">
                          <div className="degreeAccordingInnerQuestionFaqist">L’établissement a-t-il un service d’accueil des étudiants étranger?</div>
                      </div>
                      <div className="degreeAccordingInnerQuestionFaqistContain">
                          <div className="degreeAccordingInnerQuestionFaqist">Autres</div>
                      </div>
                  </div>
              </div>
              </div>
          </Accordion>
          <Accordion title="Inscription et documents requis">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi
              eligendi odit ducimus eos maiores, reiciendis numquam voluptas
          </Accordion>

          <Accordion title="Vie étudiante et logement">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi
              eligendi odit ducimus eos maiores, reiciendis numquam voluptas
          </Accordion>
          <Accordion title="Option de poursuite d’études à l’international">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi
              eligendi odit ducimus eos maiores, reiciendis numquam voluptas
          </Accordion>
          <Accordion title="Métiers envisageables - top 3 métiers">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi
              eligendi odit ducimus eos maiores, reiciendis numquam voluptas
          </Accordion>

          <Accordion title="Bourse(s) et financement des études">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi
              eligendi odit ducimus eos maiores, reiciendis numquam voluptas
          </Accordion>
          <Accordion title="Visa et immigration">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi
              eligendi odit ducimus eos maiores, reiciendis numquam voluptas
          </Accordion>
          <Accordion title="Contacter l'établissement">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi
              eligendi odit ducimus eos maiores, reiciendis numquam voluptas
          </Accordion>
              
              
          </div>
      </div>
  </div>


  <div className="divider"> </div>  
  {/*  fourth section  */}
  <div className="seventhSectionContainer">
          <div className="seventhSectionContent">This content was last updated on Thursday 16 June 2023. Every effort has been made to ensure that this information is accurate, but changes are likely to occur given the interval between the date of publishing an course start date. It is therefore very important to check this website for any updates before you apply.</div>
      </div>

      <div className="divider"> </div>
 

  {/* fifth section */}  
  <div className="sixthSectionContainer">
  <div className="commentComponentBottomBarContainer">
              <div className="commentComponentBottomBarContainerInner">
                  <div className="commentComponentBottomBarText">Que pensez-vous de l'université?</div>
                  <div className="commentComponentBottomBarButton">
                      <div className="commentComponentBottomBarButtonText">Laisser un commentaire</div>
                      <div className="commentComponentBottomBarButtonTextIcon"></div>
                  </div>
              </div>
          </div>
   </div>

   <div className="divider"> </div>
      {/* SixthSection */}

      <div className="labelLast">D’autres établissements qui pourraient vous intéresser</div>
      
      <div className='formationsPostContainer'>
          <div className="row">
              <div className="overflow-hidden">
                  <div className="row g-3 schools customSchool">
                      <Formation srcimg={tick} />
                      <Formation srcimg={tick} />
                      <Formation srcimg={tick} />
                  </div>
              </div>
          </div>
      </div>

      {/* seventh section */}

      

      {/* */}
      {/* </div>    */}
      <div className="divider"> </div>
  </React.Fragment>
    );
  }
}
Formation.propTypes = {
  formation: PropTypes.object,
  onSetFormation: PropTypes.func,
  isPreloader: PropTypes.bool,
  tokenFailed: PropTypes.bool,
  tokenRetrieved: PropTypes.bool,
  onAppTokenAsked: PropTypes.func,
  onAppTokenRetrieved: PropTypes.func,
  onPreloaderToggled: PropTypes.func,
};
const mapStateToProps = (state) => ({
  formation: state.formation,
  tokenRetrieved: state.tokenRetrieved,
  tokenFailed: state.tokenFailed,
  isPreloader: state.isPreloader,
});
const mapDispatchToProps = (dispatch) => ({
  onSetFormation: (data) => dispatch(setFormation(data)),
  onAppTokenAsked: (data) => dispatch(setAppTokenAsked(data)),
  onAppTokenRetrieved: (data) => dispatch(setAppTokenRetrieved(data)),
  onPreloaderToggled: (preload, message) =>
    dispatch(togglePreloader(preload, message)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Formation);
